import { defineEntity, custom } from './_helpers.js';

export default defineEntity('collectionCampaign', {
    launched: custom({ scope: 'state' }),
    cancelled: custom({ scope: 'state' }),
}, { includeDefaultLifecycle: false });
